module.exports = __webpack_public_path__ + "media/images/G-08-7a5432d646ddcffe8c520014a9e4600e.svg";